import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Validators, FormGroup, FormControl, UntypedFormBuilder } from '@angular/forms';
import { User } from 'src/app/domains/users/models';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'gdp-add-edit-user-form',
  templateUrl: './add-edit-user-form.component.html',
  styleUrls: ['./add-edit-user-form.component.scss']
})
export class AddEditUserFormComponent implements OnInit {
  @Input() user: User;
  @Input() loading: boolean;
  @Output() onSubmit: EventEmitter<any> = new EventEmitter<any>();
  public form: FormGroup<{
    firstName: FormControl<string>;
    lastName: FormControl<string>;
    phone: FormControl<string>;
    email: FormControl<string>;
    extension: FormControl<string>;
    password: FormControl<string>;
    repeatPassword: FormControl<string>;
  }>;
  public checkPassword: boolean = false;
  private emailPattern = /^\w+([\.-]?\w+)*@\w+([\.:-]?\w+)*(\.[a-zA-Z0-9]{2,})+$/;
  private phoneNumberPattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
  private noOnlySpacePattern = /.*[^ ].*/;
  public repeatPasswordError: boolean = false;

  constructor(private fb: UntypedFormBuilder, private translate: TranslateService) { }

  ngOnInit() {
    this.form = this.fb.group({
      firstName: new FormControl<string>(
        this.user.firstName,
        [Validators.required, Validators.pattern(this.noOnlySpacePattern)]
      ),
      lastName: new FormControl<string>(
        this.user.lastName,
        [Validators.required, Validators.pattern(this.noOnlySpacePattern)]
      ),
      phone: new FormControl<string>(
        this.user.phoneNumber,
        [Validators.pattern(this.phoneNumberPattern)]
      ),
      email: new FormControl<string>(
        this.user.email,
        [Validators.required, Validators.pattern(this.emailPattern)]
      ),
      extension: new FormControl<string>(
        this.user.extension,
        [Validators.required, Validators.pattern(/[0-9]{1,}/), Validators.maxLength(4)]
      ),
      password: new FormControl<string>(this.user.password),
      repeatPassword: new FormControl<string>(this.user.password)
    });
  }

  get language() {
    return this.translate.currentLang;
  }

  enableSubmit() {
    return this.form.valid && this.form.pristine;
  }

  isFieldValid(name: string) {
    return (
      !this.form.get(name).valid && this.form.get(name).touched
    );
  }

  submit() {
    if (this.form.valid) {
      const newUser: User = {
        ...this.user,
        firstName: this.form.get('firstName').value,
        lastName: this.form.get('lastName').value,
        phoneNumber: this.form.get('phone').value,
        email: this.form.get('email').value,
        extension: this.form.get('extension').value,
        password: this.checkPassword ? this.form.get('password').value : null
      };
      if (this.user._isEditing) {
        this.onSubmit.emit(newUser);
      } else {
        if (this.checkPassword) {
          this.form.get('password').value === this.form.get('repeatPassword').value
            ? this.onSubmit.emit(newUser)
            : this.repeatPasswordError = true;
        } else {
          this.onSubmit.emit(newUser);
        }
      }
    }
  }
}
